// extracted by mini-css-extract-plugin
module.exports = {"options":"src-components-page-portfolio-portfolio-detail-tab-inbox-threads-DocumentRequestThread-module__options--3Fv10"};